// eslint-disable-next-line import/prefer-default-export
export function getQueryParams() {
  if (typeof window !== "undefined") {
    return new URLSearchParams(window.location.search);
  }
  return new URLSearchParams();
}
